/* SORIVO — Ultimate Motion Experience
   Progressive enhancement only: every piece of content is visible without this file.
   This script adds motion state (CSS custom properties / data attributes), never rescues hidden content. */
(function () {
  'use strict';

  var root = document.querySelector('[data-sx]');
  if (!root || root.__sxInit) return;
  root.__sxInit = true;

  var html = document.documentElement;
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mqWide = window.matchMedia('(min-width: 1024px) and (min-height: 620px)');
  var mqFine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var motion = !mqReduce.matches;
  var hasIO = 'IntersectionObserver' in window;
  var vh = window.innerHeight;
  var scrub = false;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function map(v, a, b) { return clamp((v - a) / (b - a), 0, 1); }
  function smooth(t) { return t * t * (3 - 2 * t); }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function safe(fn, name) {
    try { fn(); } catch (e) { if (window.console && console.warn) console.warn('[SORIVO] ' + name, e); }
  }
  function setVar(el, name, val) { el.style.setProperty(name, val); }
  function setAttr(el, name, val) { val = String(val); if (el.getAttribute(name) !== val) el.setAttribute(name, val); }

  /* ------------------------------------------------------------------ */
  /* Colour / variant pickers                                            */
  /* ------------------------------------------------------------------ */
  function swapImg(img, src, srcset) {
    if (!img || !src) return;
    var box = img.closest('[data-sx-turn]');
    var applied = false;
    function apply() {
      if (applied) return;
      applied = true;
      if (srcset) img.setAttribute('srcset', srcset); else img.removeAttribute('srcset');
      img.setAttribute('src', src);
      if (!box) return;
      box.classList.add('is-pre');
      box.classList.remove('is-out');
      void box.offsetWidth;
      box.classList.remove('is-pre');
    }
    if (!motion || !box) { apply(); return; }
    var pre = new Image();
    if (srcset) { pre.sizes = img.getAttribute('sizes') || '100vw'; pre.srcset = srcset; }
    pre.src = src;
    box.classList.add('is-out');
    var t0 = Date.now();
    var ready = pre.decode ? pre.decode() : new Promise(function (r) { pre.onload = r; pre.onerror = r; });
    ready.then(null, function () {}).then(function () {
      setTimeout(apply, Math.max(0, 300 - (Date.now() - t0)));
    });
    /* failsafe: the image can never stay in its "out" state */
    setTimeout(apply, 1400);
  }

  function selectSwatch(pk, list, a) {
    list.forEach(function (b) {
      var on = b === a;
      b.classList.toggle('is-current', on);
      if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
    var d = a.dataset;
    $$('[data-sx-pick-label]', pk).forEach(function (n) { if (d.label) n.textContent = d.label; });
    if (d.href) $$('[data-sx-pick-href]', pk).forEach(function (n) { n.setAttribute('href', d.href); });
    if (d.price) $$('[data-sx-pick-price]', pk).forEach(function (n) { n.textContent = d.price; });
    $$('[data-sx-pick-compare]', pk).forEach(function (n) { n.textContent = d.compare || ''; });
    ['main', 'alt'].forEach(function (slot) {
      var src = d['img' + cap(slot)];
      if (!src) return;
      var set = d['srcset' + cap(slot)];
      $$('img[data-sx-slot="' + slot + '"]', pk).forEach(function (img) { swapImg(img, src, set); });
    });
  }

  function initPickers() {
    $$('[data-sx-picker]', root).forEach(function (pk) {
      var list = $$('[data-sx-swatch]', pk);
      list.forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button && e.button !== 0)) return;
          e.preventDefault();
          if (a.getAttribute('aria-current') === 'true') return;
          selectSwatch(pk, list, a);
        });
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Ecosystem index: aperture preview                                  */
  /* ------------------------------------------------------------------ */
  function initIndex() {
    var sys = $('[data-sx-index]', root);
    if (!sys) return;
    var rows = $$('[data-sx-row]', sys);
    var imgs = $$('[data-sx-pv]', sys);
    var frame = $('[data-sx-pv-frame]', sys);
    var nameEl = $('[data-sx-pv-name]', sys);
    var metaEl = $('[data-sx-pv-meta]', sys);
    var linkEl = $('[data-sx-pv-link]', sys);
    if (!rows.length || !imgs.length || !frame) return;
    var cur = 0, z = 3, hover = false, visible = false, cleanup = null;

    function activate(i, x, y) {
      var img = imgs[i];
      if (!img || i === cur) return;
      cur = i;
      img.style.setProperty('--cx', (x == null ? 50 : x).toFixed(1) + '%');
      img.style.setProperty('--cy', (y == null ? 50 : y).toFixed(1) + '%');
      img.style.zIndex = String(++z);
      img.classList.remove('is-active');
      void img.offsetWidth;
      img.classList.add('is-active');
      rows.forEach(function (r, k) { r.classList.toggle('is-active', k === i); });
      var r = rows[i];
      if (nameEl && r.dataset.name) nameEl.textContent = r.dataset.name;
      if (metaEl && r.dataset.meta) metaEl.textContent = r.dataset.meta;
      if (linkEl && r.dataset.url) linkEl.setAttribute('href', r.dataset.url);
      clearTimeout(cleanup);
      cleanup = setTimeout(function () {
        imgs.forEach(function (im, k) { if (k !== cur) im.classList.remove('is-active'); });
      }, 1100);
    }

    rows.forEach(function (r, i) {
      r.addEventListener('pointerenter', function (e) {
        hover = true;
        var fr = frame.getBoundingClientRect();
        if (!fr.width) return;
        var x = clamp((e.clientX - fr.left) / fr.width * 100, 0, 100);
        var y = clamp((e.clientY - fr.top) / fr.height * 100, 0, 100);
        activate(i, x, y);
      });
      r.addEventListener('focusin', function () { activate(i, 0, 50); });
    });
    sys.addEventListener('pointerleave', function () { hover = false; });

    if (motion && hasIO) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.3 }).observe(frame);
      setInterval(function () {
        if (!visible || hover || document.hidden || frame.offsetParent === null) return;
        activate((cur + 1) % imgs.length, 0, 50);
      }, 3600);
    }
  }

  /* ------------------------------------------------------------------ */
  /* FoldCharge flip                                                     */
  /* ------------------------------------------------------------------ */
  function initFlips() {
    $$('[data-sx-flip]', root).forEach(function (fl) {
      var scope = fl.closest('section') || root;
      var btns = $$('[data-sx-flip-to]', scope);
      var touched = false;
      function set(state) {
        fl.setAttribute('data-state', state);
        btns.forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-sx-flip-to') === state ? 'true' : 'false');
        });
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () { touched = true; set(b.getAttribute('data-sx-flip-to')); });
      });
      var card = $('[data-sx-flip-card]', fl);
      if (card) {
        card.addEventListener('click', function () {
          touched = true;
          set(fl.getAttribute('data-state') === 'folded' ? 'open' : 'folded');
        });
      }
      if (motion && hasIO) {
        var o = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return;
          o.disconnect();
          setTimeout(function () { if (!touched) set('folded'); }, 1000);
          setTimeout(function () { if (!touched) set('open'); }, 3800);
        }, { threshold: 0.55 });
        o.observe(fl);
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Before / after comparison                                           */
  /* ------------------------------------------------------------------ */
  function initCompare() {
    $$('[data-sx-compare]', root).forEach(function (cmp) {
      var range = $('[data-sx-compare-range]', cmp);
      if (!range) return;
      var user = false;
      function set(v) { cmp.style.setProperty('--pos', v); }
      range.addEventListener('input', function () { user = true; set(range.value); });
      if (!motion || !hasIO) return;
      var primed = false, played = false;
      var o = new IntersectionObserver(function (entries) {
        var en = entries[0];
        if (!en.isIntersecting || user) return;
        if (!primed && en.intersectionRatio < 0.45) { primed = true; set(92); range.value = 92; return; }
        if (en.intersectionRatio >= 0.45 && !played) {
          played = true;
          o.disconnect();
          var from = primed ? 92 : 50, to = 32, dur = 1900, t0 = 0;
          var step = function (ts) {
            if (user) return;
            if (!t0) t0 = ts;
            var t = clamp((ts - t0) / dur, 0, 1);
            var e = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
            var v = from + (to - from) * e;
            set(v.toFixed(2));
            range.value = Math.round(v);
            if (t < 1) window.requestAnimationFrame(step);
          };
          setTimeout(function () { window.requestAnimationFrame(step); }, 200);
        }
      }, { threshold: [0, 0.45] });
      o.observe(cmp);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Pointer: magnetic buttons, hero depth, card tilt                    */
  /* ------------------------------------------------------------------ */
  function initPointer() {
    if (!motion || !mqFine.matches) return;

    $$('[data-sx-magnetic]', root).forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = e.clientX - (r.left + r.width / 2);
        var y = e.clientY - (r.top + r.height / 2);
        el.classList.add('is-magnet');
        el.style.setProperty('--tx', (x * 0.22).toFixed(1) + 'px');
        el.style.setProperty('--ty', (y * 0.34).toFixed(1) + 'px');
      });
      el.addEventListener('pointerleave', function () {
        el.classList.remove('is-magnet');
        el.style.setProperty('--tx', '0px');
        el.style.setProperty('--ty', '0px');
      });
    });

    var hero = $('[data-sx-hero]', root);
    var stage = hero && $('[data-sx-stage]', hero);
    if (stage) {
      var mx = 0, my = 0, raf = 0;
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        mx = ((e.clientX - r.left) / r.width - 0.5) * 2;
        my = ((e.clientY - r.top) / r.height - 0.5) * 2;
        if (!raf) raf = window.requestAnimationFrame(function () {
          raf = 0;
          stage.style.setProperty('--mx', mx.toFixed(3));
          stage.style.setProperty('--my', my.toFixed(3));
        });
      });
      hero.addEventListener('pointerleave', function () {
        stage.style.setProperty('--mx', '0');
        stage.style.setProperty('--my', '0');
      });
    }

    $$('[data-sx-tilt-card]', root).forEach(function (el) {
      var raf2 = 0, rx = 0, ry = 0;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        ry = ((e.clientX - r.left) / r.width - 0.5) * 8;
        rx = -((e.clientY - r.top) / r.height - 0.5) * 7;
        if (!raf2) raf2 = window.requestAnimationFrame(function () {
          raf2 = 0;
          el.style.setProperty('--rx', rx.toFixed(2) + 'deg');
          el.style.setProperty('--ry', ry.toFixed(2) + 'deg');
        });
      });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--rx', '0deg');
        el.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* HaloSound clock                                                     */
  /* ------------------------------------------------------------------ */
  function initClock() {
    var els = $$('[data-sx-clock]', root);
    if (!els.length) return;
    function tick() {
      var d = new Date();
      var h = ('0' + d.getHours()).slice(-2), m = ('0' + d.getMinutes()).slice(-2);
      els.forEach(function (el) {
        var hh = $('[data-h]', el), mm = $('[data-m]', el);
        if (hh) hh.textContent = h;
        if (mm) mm.textContent = m;
      });
    }
    tick();
    setInterval(tick, 15000);
  }

  /* ------------------------------------------------------------------ */
  /* In-view reveals (CSS animation that always completes on its own)    */
  /* ------------------------------------------------------------------ */
  function initReveals() {
    if (!hasIO) return;
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); rio.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px 6% 0px' });
    $$('.sx-rv', root).forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) return; /* already on screen at load: stay static */
      rio.observe(el);
    });

    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); vio.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -18% 0px' });
    $$('[data-sx-inview]', root).forEach(function (el) { vio.observe(el); });
  }

  /* ------------------------------------------------------------------ */
  /* Scroll engine                                                       */
  /* ------------------------------------------------------------------ */
  var scenes = [];
  var ticking = false;
  var docH = 0;
  var bar = null;
  /* Horizon scrolls inside .page-wrapper on desktop (html/body are overflow:hidden). */
  var scroller = null;
  function findScroller() {
    var pw = document.querySelector('.page-wrapper');
    scroller = null;
    if (pw) {
      var o = window.getComputedStyle(pw).overflowY;
      if (o === 'auto' || o === 'scroll') scroller = pw;
    }
  }
  var sio = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      (en.target.__sx || []).forEach(function (s) { s.on = en.isIntersecting; });
    });
    request();
  }, { rootMargin: '30% 0px 30% 0px' }) : null;

  function addScene(el, kind, fn) {
    if (!el) return;
    var s = { el: el, kind: kind, fn: fn, on: !sio };
    (el.__sx = el.__sx || []).push(s);
    scenes.push(s);
    if (sio) sio.observe(el);
  }

  function progressOf(s, r) {
    if (s.kind === 'sticky') {
      var d = r.height - vh;
      return d > 0 ? clamp(-r.top / d, 0, 1) : (r.top < 0 ? 1 : 0);
    }
    if (s.kind === 'enter') return clamp((vh - r.top) / (vh * 0.8), 0, 1);
    if (s.kind === 'leave') return clamp(-r.top / Math.max(r.height, 1), 0, 1);
    return clamp((vh - r.top) / (vh + r.height), 0, 1); /* pass */
  }

  function frame() {
    ticking = false;
    var list = [], i, s;
    for (i = 0; i < scenes.length; i++) {
      s = scenes[i];
      if (s.on) list.push([s, s.el.getBoundingClientRect()]);
    }
    var y = scroller ? scroller.scrollTop : (window.pageYOffset || html.scrollTop || 0);
    var span = scroller ? scroller.scrollHeight - scroller.clientHeight : docH - vh;
    for (i = 0; i < list.length; i++) {
      s = list[i][0];
      s.fn(progressOf(s, list[i][1]));
    }
    if (bar && span > 0) bar.style.transform = 'scaleX(' + clamp(y / span, 0, 1).toFixed(4) + ')';
  }

  function request() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(frame); }
  }

  function measure() {
    findScroller();
    vh = window.innerHeight;
    docH = Math.max(document.body.scrollHeight, html.scrollHeight);
  }

  function setMode() {
    var want = motion && mqWide.matches;
    html.classList.toggle('sx-wide', mqWide.matches);
    if (want !== scrub) {
      scrub = want;
      root.classList.toggle('is-scrub', scrub);
      if (!scrub) {
        /* hand control back to the static / step layouts */
        $$('[data-sx-aperture]', root).forEach(function (el) { el.style.removeProperty('--a'); });
        var hero = $('[data-sx-hero]', root);
        if (hero) hero.style.removeProperty('--h');
        resetOrbit();
        var snap = $('[data-sx-snap]', root);
        if (snap) { snap.removeAttribute('data-step'); snap.style.removeProperty('--sp'); }
      } else {
        var hero2 = $('[data-sx-hero]', root);
        if (hero2) hero2.style.removeProperty('--hm');
      }
    }
    measure();
    request();
  }

  function haloApply(el, st) {
    setVar(el, '--light', st.l.toFixed(3));
    setVar(el, '--sound', st.s.toFixed(3));
    setVar(el, '--charge', st.c.toFixed(3));
    setVar(el, '--wake', st.w.toFixed(3));
    setAttr(el, 'data-step', st.step);
  }

  function stepObserver(items, cb) {
    if (!hasIO) return;
    var o = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) cb(parseInt(en.target.getAttribute('data-i'), 10) || 0);
      });
    }, { rootMargin: '-44% 0px -44% 0px' });
    items.forEach(function (it) { o.observe(it); });
  }

  /* ------------------------------------------------------------------ */
  /* Product orbit                                                       */
  /* ------------------------------------------------------------------ */
  var orbit = { sec: $('[data-sx-orbit]', root), items: [], rx: 0, ry: 0 };
  if (orbit.sec) {
    orbit.stage = $('[data-sx-orbit-stage]', orbit.sec);
    orbit.list = $('[data-sx-orbit-list]', orbit.sec);
    orbit.ring = $('.sx-orbit__ring i', orbit.sec);
    orbit.items = $$('[data-sx-orbit-item]', orbit.sec);
  }
  function orbitGeo() {
    var r = orbit.stage.getBoundingClientRect();
    var w = r.width, h = r.height;
    if (!w || !h) return;
    var iw = Math.max(120, Math.min(h * 0.36, w * 0.15, 240));
    orbit.rx = Math.min(w * 0.34, 540);
    orbit.ry = Math.max(56, h / 2 - iw / 2 - 50);
    orbit.sec.style.setProperty('--iw', iw.toFixed(0) + 'px');
    orbit.sec.style.setProperty('--rx', orbit.rx.toFixed(0) + 'px');
    orbit.sec.style.setProperty('--ry', orbit.ry.toFixed(0) + 'px');
  }
  function orbitPlace(p) {
    var n = orbit.items.length, rot = p * 144, i, a, d, el;
    for (i = 0; i < n; i++) {
      a = (90 + i * (360 / n) - rot) * Math.PI / 180;
      d = (Math.sin(a) + 1) / 2; /* 1 = front, 0 = back */
      el = orbit.items[i];
      el.style.transform = 'translate3d(' + (Math.cos(a) * orbit.rx).toFixed(1) + 'px,' + (Math.sin(a) * orbit.ry).toFixed(1) + 'px,0) scale(' + (0.56 + 0.44 * d).toFixed(3) + ')';
      el.style.opacity = (0.38 + 0.62 * d).toFixed(3);
      el.style.zIndex = d > 0.5 ? 10 + Math.round(d * 10) : 1 + Math.round(d * 4);
    }
    if (orbit.ring) orbit.ring.style.setProperty('--rot', (-rot * 1.5).toFixed(1) + 'deg');
  }
  function resetOrbit() {
    orbit.rx = 0;
    orbit.items.forEach(function (el) {
      el.style.removeProperty('transform');
      el.style.removeProperty('opacity');
      el.style.removeProperty('z-index');
    });
  }
  function initOrbitRail() {
    if (!orbit.sec || !orbit.list) return;
    var step = function (dir) {
      var it = orbit.items[0];
      var dx = it ? it.getBoundingClientRect().width + 14 : 280;
      orbit.list.scrollBy({ left: dir * dx, behavior: motion ? 'smooth' : 'auto' });
    };
    var pv = $('[data-sx-orbit-prev]', orbit.sec), nx = $('[data-sx-orbit-next]', orbit.sec);
    if (pv) pv.addEventListener('click', function () { step(-1); });
    if (nx) nx.addEventListener('click', function () { step(1); });
    if (!hasIO || !motion) return;
    orbit.sec.classList.add('is-rail');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.target.classList.toggle('is-active', en.intersectionRatio >= 0.6); });
    }, { root: orbit.list, threshold: [0, 0.6, 1] });
    orbit.items.forEach(function (el) { io.observe(el); });
  }

  function initScenes() {
    bar = $('[data-sx-progress]', root);

    /* hero depth while leaving */
    var hero = $('[data-sx-hero]', root);
    addScene(hero, 'leave', function (p) {
      if (!scrub) { setVar(hero, '--hm', p.toFixed(4)); return; }
      setVar(hero, '--h', p.toFixed(4));
    });

    /* product orbit: five objects turn around SORIVO (desktop scrub only) */
    if (orbit.sec) {
      addScene(orbit.sec, 'sticky', function (p) {
        if (!scrub) return;
        if (!orbit.rx) orbitGeo();
        orbitPlace(p);
      });
    }

    /* FoldCharge: devices glide toward the charger as the scene enters */
    var dock = $('[data-sx-dock]', root);
    addScene(dock, 'enter', function (p) {
      setVar(dock, '--dock', smooth(map(p, 0.2, 0.9)).toFixed(4));
    });

    /* aperture openings */
    $$('[data-sx-aperture]', root).forEach(function (el) {
      addScene(el, 'enter', function (p) {
        if (!scrub) return;
        setVar(el, '--a', smooth(p).toFixed(4));
      });
    });

    /* SnapFold sticky story */
    var snap = $('[data-sx-snap]', root);
    addScene(snap, 'sticky', function (p) {
      if (!scrub) return;
      var step = p < 0.24 ? 0 : p < 0.49 ? 1 : p < 0.74 ? 2 : 3;
      setAttr(snap, 'data-step', step);
      setVar(snap, '--sp', p.toFixed(4));
    });

    /* HaloSound: LIGHT · SOUND · CHARGE · WAKE */
    var halo = $('[data-sx-halo]', root);
    if (halo && hasIO) {
      halo.classList.add('is-enhanced');
      addScene(halo, 'sticky', function (p) {
        if (!scrub) return;
        var st = {
          l: smooth(map(p, 0.03, 0.18)),
          s: smooth(map(p, 0.23, 0.3)),
          c: map(p, 0.41, 0.55),
          w: smooth(map(p, 0.59, 0.66)),
          step: p < 0.05 ? -1 : p < 0.23 ? 0 : p < 0.41 ? 1 : p < 0.59 ? 2 : p < 0.78 ? 3 : 4
        };
        haloApply(halo, st);
      });
      stepObserver($$('.sx-halo__ch', halo), function (i) {
        if (scrub) return;
        halo.classList.add('is-steps');
        haloApply(halo, { l: 1, s: i >= 1 ? 1 : 0, c: i >= 2 ? 1 : 0, w: i >= 3 ? 1 : 0, step: i });
      });
      /* narrow screens: start dim only once the scene is about to be seen */
      if (hasIO) {
        var hio = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting || scrub) return;
          hio.disconnect();
          if (!halo.hasAttribute('data-step')) {
            halo.classList.add('is-steps');
            haloApply(halo, { l: 0.12, s: 0, c: 0, w: 0, step: -1 });
          }
        }, { rootMargin: '0px 0px 10% 0px' });
        hio.observe(halo);
      }
    }

    /* Manifesto */
    var man = $('[data-sx-man]', root);
    if (man && hasIO) {
      man.classList.add('is-enhanced');
      addScene(man, 'sticky', function (p) {
        if (!scrub) return;
        var step = Math.min(3, Math.floor(map(p, 0.06, 0.9) * 4));
        setAttr(man, 'data-step', step);
      });
      stepObserver($$('.sx-man__line', man), function (i) {
        if (scrub) return;
        setAttr(man, 'data-step', i);
      });
    }

    /* FlexStand dial */
    var flex = $('[data-sx-flex]', root);
    var readout = flex && $('[data-sx-angle]', flex);
    addScene(flex, 'pass', function (p) {
      var ang = 14 + 64 * smooth(map(p, 0.12, 0.88));
      setVar(flex, '--ang', ang.toFixed(1));
      if (readout) readout.textContent = Math.round(ang);
    });

    /* Final lineup convergence */
    var fin = $('[data-sx-final]', root);
    addScene(fin, 'pass', function (p) {
      setVar(fin, '--f', smooth(map(p, 0.06, 0.42)).toFixed(4));
    });

    /* capture phase catches scrolling of the window AND of Horizon's .page-wrapper */
    document.addEventListener('scroll', request, { passive: true, capture: true });
    window.addEventListener('resize', function () { measure(); orbit.rx = 0; request(); }, { passive: true });
    window.addEventListener('load', function () { measure(); request(); });
    if (mqWide.addEventListener) mqWide.addEventListener('change', setMode); else if (mqWide.addListener) mqWide.addListener(setMode);
    setMode();
    root.classList.add('has-progress');
  }

  /* ------------------------------------------------------------------ */
  /* Chapter indicator                                                   */
  /* ------------------------------------------------------------------ */
  function initChapters() {
    var ui = $('[data-sx-chapter-ui]', root);
    if (!ui || !hasIO) return;
    var num = $('[data-sx-chapter-num]', ui), nm = $('[data-sx-chapter-name]', ui);
    var live = [];
    var o = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var idx = live.indexOf(en.target);
        if (en.isIntersecting && idx < 0) live.push(en.target);
        if (!en.isIntersecting && idx > -1) live.splice(idx, 1);
      });
      var el = live[live.length - 1];
      if (el) {
        num.textContent = el.getAttribute('data-sx-chapter');
        nm.textContent = el.getAttribute('data-sx-chapter-name');
        ui.classList.add('is-on');
      } else {
        ui.classList.remove('is-on');
      }
    }, { rootMargin: '-49% 0px -50% 0px' });
    $$('[data-sx-chapter]', root).forEach(function (s) { o.observe(s); });
  }

  /* ------------------------------------------------------------------ */
  safe(initPickers, 'pickers');
  safe(initOrbitRail, 'orbit');
  safe(initIndex, 'index');
  safe(initFlips, 'flip');
  safe(initCompare, 'compare');
  safe(initClock, 'clock');
  safe(initPointer, 'pointer');
  root.classList.add('is-live');
  if (motion) {
    safe(initReveals, 'reveals');
    safe(initScenes, 'scenes');
    safe(initChapters, 'chapters');
  }
})();